import type BaseEnumType from "@/app/services/baseEnumType";

export class EnumListItemStatus implements BaseEnumType {
  private static allValues: EnumListItemStatus[] = [];

  public static none = new EnumListItemStatus(0, "", "");
  public static warn = new EnumListItemStatus(1, "error", "icon-warn-medium");
  public static in_progress = new EnumListItemStatus(
    2,
    "check_circle",
    "icon-warn-medium"
  );
  public static ok = new EnumListItemStatus(
    3,
    "check_circle",
    "icon-successful-medium"
  );
  public static failed = new EnumListItemStatus(
    4,
    "error",
    "icon-error-medium"
  );
  public static locked = new EnumListItemStatus(5, "lock", "icon-error-medium");
  public static offline = new EnumListItemStatus(6, "signal_wifi_off", "");

  public key: number;
  public value: string;
  public className: string;

  private constructor(key: number, value: string, className: string) {
    this.key = key;
    this.value = value;
    this.className = className;
    EnumListItemStatus.allValues.push(this);
  }

  public static getValues(): EnumListItemStatus[] {
    return EnumListItemStatus.allValues;
  }

  public static getByKey(key: number): EnumListItemStatus {
    const found = EnumListItemStatus.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumListItemStatus - Key not found: ${key}`);
    }

    return found;
  }
}

export interface IListItem {
  key: string;
  title: string;
  subtitle?: string;
  text?: string;
  status?: EnumListItemStatus;
  disabled?: boolean;
  action?: () => void;
}
